import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
    getCartDetailFunction
} from '../../redux/actions/cartActions';
import axios from 'axios';
import { axiosinstance } from '../../configAxios';
import SecureLS from 'secure-ls';
import MessageInfoBox from '../../components/other/MessageInfoBox';

const RemoveCartItem = (props) => {

    const dispatch = useDispatch();
    const getActiveCartFunction = useSelector((state) => state.getActiveCartFunction);

    let ls = new SecureLS({ encodingType: 'aes' });
    const item = props.item;
    const anStockKey = props.anStockKey;

    //funkcija koja poziva funkciju za snimanje u korpu
    const functionSetQty = () => {

        var userInfoData = ls.get('userInfo');
        var activeCurrency = JSON.parse(localStorage.getItem('activeCurrency'));

        const attributes = {};
        attributes['anCompanyKey'] = userInfoData ? userInfoData.company.anCompanyKey : 0;
        attributes['anUserKey'] = userInfoData ? userInfoData.company.department[0].user[0].anUserKey : '0';
        attributes['acCartKey'] = getActiveCartFunction[0]._id ? getActiveCartFunction[0]._id : '';
        attributes['anProductKey'] = item.anProductKey;
        attributes['anQty'] = -item.anQty;
        attributes['anCurrency'] = activeCurrency._id;
        attributes['isRelated'] = item.isRelatedSale;
        attributes['anStock'] = anStockKey;

        const configRes = axiosinstance(attributes, '8224', 'addItemToCart');

        axios(configRes)
            .then(function (response) {
                if (response.data.response.acInfoMessage) {
                    response.data.response.acInfoMessage = response.data.response.acInfoMessage.split(":")[0];
                    toast(<MessageInfoBox message={response.data.response.acInfoMessage} type={0} />, {
                        className: 'red-background',
                    });
                    if (response.data.response.acInfoMessage.includes("relatedSaleQtyNotAllowed")) {

                    }
                } else if (response.data.response.acMsg) {
                    toast(<MessageInfoBox message={response.data.response.acMsg} type={response.data.response.isOk} />, {
                        className: response.data.response.isOk == 1 ? 'green-background' : 'red-background',
                    });
                } else if (response.data.isOk == 0) {
                    toast(<MessageInfoBox message={response.data.acMsg} type={response.data.isOk} />, {
                        className: response.data.isOk == 1 ? 'green-background' : 'red-background',
                    });
                }

                dispatch(getCartDetailFunction(getActiveCartFunction[0]._id)); // osvezavanje korpe
            })
            .catch(function (error) {
                toast(<MessageInfoBox message="globalError" type="0" />, {
                    className: 'red-background',
                });
            });
    };

    return (
        <div
            className="remove-cart-item"
            onClick={(e) => functionSetQty()}
        >
            <i className="far fa-times-circle"></i>
        </div>
    );
};

export default RemoveCartItem;